import i18next from 'i18next';
import { ClinicInvoiceBillingType } from 'infrastructure/enums';

export interface IClinicInvoiceBillingTypeItem {
  id: ClinicInvoiceBillingType;
  name: string;
}

export const clinicInvoiceBillingTypesDataSource =
  (): IClinicInvoiceBillingTypeItem[] => {
    return [
      {
        id: ClinicInvoiceBillingType.ONE_TIME,
        name: i18next.t('clinicInvoiceBillingTypes.one_time'),
      },
      {
        id: ClinicInvoiceBillingType.MONTHLY,
        name: i18next.t('clinicInvoiceBillingTypes.monthly'),
      },
      {
        id: ClinicInvoiceBillingType.MONTHLY_ADD_ON,
        name: i18next.t('clinicInvoiceBillingTypes.monthly_add_on'),
      },
      {
        id: ClinicInvoiceBillingType.INITIAL_MONTH,
        name: i18next.t('clinicInvoiceBillingTypes.initial_month'),
      },
    ];
  };
